module.exports = __webpack_public_path__ + "img/hotel.a5f84205.svg";